import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, unref as _unref, normalizeClass as _normalizeClass, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "t-table" }
const _hoisted_2 = { width: "20%" }
const _hoisted_3 = { width: "30%" }
const _hoisted_4 = { width: "25%" }
const _hoisted_5 = {
  width: "25%",
  class: "t-table-data"
}
const _hoisted_6 = { "data-qe-id": "table-data" }
const _hoisted_7 = {
  key: 0,
  class: "qualified-list-end-row",
  "data-qe-id": "qualified-list-end-row"
}
const _hoisted_8 = {
  key: 1,
  class: "no-results",
  "data-qe-id": "no-results-available-row"
}

import { ref, watch } from 'vue'
import CTableRow from '@/components/ranking/season/CTableRow.vue'
import { SeasonRankingUI } from '@/model/ranking/Season'
import { TableFilter } from '@/model/ranking/TableFilter'

const COLSPAN_NUM = 4

export default /*@__PURE__*/_defineComponent({
  __name: 'CScoreTable',
  props: {
    data: {},
    isSearchActive: { type: Boolean },
    lastQualifiedRank: {},
    maxRows: {},
    myRank: {}
  },
  emits: ['show-more'],
  setup(__props: any, { emit: __emit }) {

const props = __props
const emit = __emit

const ROW_TYPE: TableFilter = TableFilter.SCORES

const listEndPosition = ref(0)

watch(
  () => props.data,
  (newData: Array<SeasonRankingUI>, oldData: Array<SeasonRankingUI>) => {
    if (newData.length > 1) {
      // If data contains more than one item set marker for end of qualified-list to rank of first unqualified user
      const qualifieds = newData.filter((ranking) => !isUserQualified(ranking))
      if (qualifieds.length > 0) {
        // first user which does not qualify
        listEndPosition.value = parseInt(qualifieds.shift().seasonRank)
      } else {
        listEndPosition.value = props.lastQualifiedRank
      }
    } else if (newData.length === 1) {
      // If data contains just one item check whether they are qualified and set marker accordingly
      if (isUserQualified(newData[0])) {
        listEndPosition.value = props.lastQualifiedRank
      } else {
        listEndPosition.value = parseInt(newData[0].seasonRank)
      }
    }
  },
  { immediate: true }
)

function isMyUser(user: SeasonRankingUI) {
  return user.playerId === props.myRank.playerId
}

function isUserQualified(user: SeasonRankingUI): boolean {
  return parseInt(user.seasonRank) <= props.lastQualifiedRank
}

function isUserInViewPort(user: SeasonRankingUI): boolean {
  return props.data.filter((ranking) => ranking.playerId === user.playerId).length > 0
}

function isTicketUser(user: SeasonRankingUI): boolean {
  return !!user.ticketInfo
}

function onShowMore() {
  emit('show-more')
}

return (_ctx: any,_cache: any) => {
  const _component_t_tooltip = _resolveComponent("t-tooltip")!

  return (_openBlock(), _createElementBlock("table", _hoisted_1, [
    _createElementVNode("thead", null, [
      _createElementVNode("tr", null, [
        _createElementVNode("td", _hoisted_2, _toDisplayString(_ctx.$t('table.columns.rank')), 1),
        _createElementVNode("td", _hoisted_3, _toDisplayString(_ctx.$t('table.columns.playerName')), 1),
        _createElementVNode("td", _hoisted_4, _toDisplayString(_ctx.$t('table.columns.score')), 1),
        _createElementVNode("td", _hoisted_5, [
          _createElementVNode("div", null, [
            _createTextVNode(_toDisplayString(_ctx.$t('table.columns.totalWin')) + " ", 1),
            _createVNode(_component_t_tooltip, {
              class: "tooltip",
              text: _ctx.$t('table.info.totalWin')
            }, {
              default: _withCtx(() => _cache[0] || (_cache[0] = [
                _createElementVNode("i", { class: "icf-info" }, null, -1)
              ])),
              _: 1,
              __: [0]
            }, 8, ["text"])
          ])
        ])
      ])
    ]),
    _createElementVNode("tbody", _hoisted_6, [
      (_ctx.data.length > 0)
        ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.data, (user) => {
              return (_openBlock(), _createElementBlock(_Fragment, {
                key: user.playerName
              }, [
                (listEndPosition.value !== _ctx.lastQualifiedRank && listEndPosition.value === parseInt(user.seasonRank))
                  ? (_openBlock(), _createElementBlock("tr", {
                      class: "qualified-list-end-row",
                      key: `${user.playerName}_last_row_before`,
                      "data-qe-id": "qualified-list-end-row"
                    }, [
                      _createElementVNode("td", { colspan: COLSPAN_NUM }, _toDisplayString(_ctx.$t('table.more.list_end')), 1)
                    ]))
                  : _createCommentVNode("", true),
                _createVNode(CTableRow, {
                  highlighted: isMyUser(user),
                  ranking: user,
                  type: _unref(ROW_TYPE),
                  class: _normalizeClass(isUserQualified(user) ? 'qualified' : false)
                }, null, 8, ["highlighted", "ranking", "type", "class"])
              ], 64))
            }), 128)),
            ((_ctx.lastQualifiedRank > _ctx.data.length && !_ctx.isSearchActive) || listEndPosition.value === _ctx.lastQualifiedRank)
              ? (_openBlock(), _createElementBlock("tr", _hoisted_7, [
                  _createElementVNode("td", { colspan: COLSPAN_NUM }, _toDisplayString(_ctx.$t('table.more.list_end')), 1)
                ]))
              : _createCommentVNode("", true),
            (_ctx.maxRows > _ctx.data.length)
              ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                  _createElementVNode("tr", null, [
                    _createElementVNode("td", {
                      class: "dots",
                      colspan: COLSPAN_NUM
                    }, "• • •")
                  ]),
                  _createElementVNode("tr", null, [
                    _createElementVNode("td", {
                      class: "show-more-row",
                      colspan: COLSPAN_NUM,
                      onClick: onShowMore,
                      "data-qe-id": "show-more-link"
                    }, [
                      _createTextVNode(_toDisplayString(_ctx.$t('table.more.button')) + " ", 1),
                      _cache[1] || (_cache[1] = _createElementVNode("i", { class: "icf-arrowBottom" }, null, -1))
                    ])
                  ])
                ], 64))
              : _createCommentVNode("", true),
            (!_ctx.isSearchActive && !isUserQualified(_ctx.myRank) && !isUserInViewPort(_ctx.myRank) && !isTicketUser(_ctx.myRank))
              ? (_openBlock(), _createBlock(CTableRow, {
                  key: 2,
                  highlighted: true,
                  ranking: _ctx.myRank,
                  type: _unref(ROW_TYPE)
                }, null, 8, ["ranking", "type"]))
              : _createCommentVNode("", true)
          ], 64))
        : (_openBlock(), _createElementBlock("tr", _hoisted_8, [
            _createElementVNode("td", { colspan: COLSPAN_NUM }, _toDisplayString(_ctx.$t('table.more.no_results')), 1)
          ]))
    ])
  ]))
}
}

})